import styled from "styled-components";
import { Link } from "react-router-dom";

export const ForumSection = styled.section`
  width: 100%;
  min-height: calc(100vh - 70px);
  display: flex;
  justify-content: center;
  padding: 56px 20px 90px;
  background:
    radial-gradient(circle at top left, rgba(40, 172, 48, 0.12), transparent 32%),
    linear-gradient(180deg, #f8fbf8 0%, #eef8ef 100%);
`;

export const ForumShell = styled.div`
  width: 100%;
  max-width: 1180px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const HeroCard = styled.div`
  border-radius: 28px;
  padding: 32px;
  background:
    linear-gradient(135deg, rgba(40, 172, 48, 0.96) 0%, rgba(10, 134, 80, 0.96) 100%);
  color: #ffffff;
  box-shadow: 0 24px 48px rgba(12, 124, 32, 0.18);

  @media (max-width: 768px) {
    padding: 26px 20px;
    border-radius: 22px;
  }
`;

export const HeroEyebrow = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const HeroTitle = styled.h1`
  margin: 18px 0 12px;
  font-size: 2.45rem;
  line-height: 1.15;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const HeroText = styled.p`
  max-width: 760px;
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.75;
  font-size: 1rem;
`;

export const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 24px;
`;

export const PrimaryButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 48px;
  padding: 0 22px;
  border-radius: 999px;
  background: #ffffff;
  color: #0a8650;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(255, 255, 255, 0.18);
  }
`;

export const SecondaryButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 48px;
  padding: 0 22px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.08);
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.16);
  }
`;

export const ControlsCard = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(220px, 260px);
  gap: 18px;
  padding: 24px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(24, 54, 29, 0.08);

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  min-height: 52px;
  border-radius: 16px;
  border: 1px solid rgba(40, 172, 48, 0.22);
  padding: 0 18px;
  font-size: 1rem;
  background: #f9fcf9;
  color: #1a1a1a;

  &:focus {
    outline: none;
    border-color: #28ac30;
    box-shadow: 0 0 0 4px rgba(40, 172, 48, 0.12);
  }
`;

export const Select = styled.select`
  width: 100%;
  min-height: 52px;
  border-radius: 16px;
  border: 1px solid rgba(40, 172, 48, 0.22);
  padding: 0 18px;
  font-size: 1rem;
  background: #f9fcf9;
  color: #1a1a1a;

  &:focus {
    outline: none;
    border-color: #28ac30;
    box-shadow: 0 0 0 4px rgba(40, 172, 48, 0.12);
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 0.8fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Panel = styled.div`
  padding: 24px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(24, 54, 29, 0.08);
`;

export const PanelTitle = styled.h2`
  margin: 0 0 14px;
  font-size: 1.15rem;
  color: #0b3112;
`;

export const PanelText = styled.p`
  margin: 0;
  color: #4f5d52;
  line-height: 1.75;
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: #4f5d52;
  line-height: 1.8;
`;

export const Card = styled.article`
  padding: 24px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(24, 54, 29, 0.08);
  border: 1px solid rgba(40, 172, 48, 0.08);
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  margin-bottom: 16px;
`;

export const MetaPill = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  background: ${({ $accent }) => ($accent ? "rgba(40, 172, 48, 0.12)" : "#f4f7f4")};
  color: ${({ $accent }) => ($accent ? "#10753b" : "#506053")};
`;

export const CardTitleLink = styled(Link)`
  display: inline-block;
  margin-bottom: 12px;
  color: #102813;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.35;

  &:hover {
    color: #0a8650;
  }
`;

export const CardTitle = styled.h2`
  margin: 0 0 12px;
  color: #102813;
  font-size: 1.8rem;
  line-height: 1.35;
`;

export const CardExcerpt = styled.p`
  margin: 0;
  color: #4f5d52;
  line-height: 1.78;
  white-space: pre-wrap;
`;

export const InlineRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
`;

export const TextButton = styled(Link)`
  color: #0a8650;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const MetaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: #10753b;
  text-decoration: none;
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: #0a8650;
    transform: translateY(-1px);
    text-decoration: underline;
  }
`;

export const EmptyState = styled.div`
  padding: 34px 24px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(24, 54, 29, 0.08);
  text-align: center;
`;

export const EmptyTitle = styled.h3`
  margin: 0 0 10px;
  font-size: 1.3rem;
  color: #17331b;
`;

export const EmptyText = styled.p`
  margin: 0;
  color: #5b695e;
  line-height: 1.75;
`;

export const FormCard = styled.div`
  padding: 28px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(24, 54, 29, 0.08);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #17331b;
`;

export const Input = styled.input`
  width: 100%;
  min-height: 50px;
  border-radius: 14px;
  border: 1px solid rgba(40, 172, 48, 0.2);
  padding: 0 16px;
  font-size: 0.98rem;
  background: #fbfdfb;

  &:focus {
    outline: none;
    border-color: #28ac30;
    box-shadow: 0 0 0 4px rgba(40, 172, 48, 0.12);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 180px;
  border-radius: 16px;
  border: 1px solid rgba(40, 172, 48, 0.2);
  padding: 14px 16px;
  font-size: 0.98rem;
  background: #fbfdfb;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #28ac30;
    box-shadow: 0 0 0 4px rgba(40, 172, 48, 0.12);
  }
`;

export const Button = styled.button`
  min-height: 50px;
  width: fit-content;
  padding: 0 24px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(90deg, #0a8650, #28ac30);
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(10, 134, 80, 0.24);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const HelperText = styled.p`
  margin: 0;
  color: #607165;
  line-height: 1.7;
  font-size: 0.95rem;
`;

export const Notice = styled.div`
  padding: 14px 16px;
  border-radius: 16px;
  background: ${({ $type }) =>
    $type === "error" ? "rgba(199, 63, 63, 0.09)" : "rgba(40, 172, 48, 0.1)"};
  color: ${({ $type }) => ($type === "error" ? "#a22f2f" : "#156d36")};
  font-weight: 500;
  line-height: 1.6;
`;

export const HiddenField = styled.input`
  display: none;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const PaginationText = styled.span`
  color: #5b695e;
  font-size: 0.95rem;
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const SmallButton = styled.button`
  min-width: 110px;
  min-height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(40, 172, 48, 0.22);
  background: #ffffff;
  color: #0a8650;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const PageNumberButton = styled.button`
  min-width: 42px;
  height: 42px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.primary : "rgba(40, 172, 48, 0.22)"};
  background: ${({ $active, theme }) =>
    $active ? theme.primary : "#ffffff"};
  color: ${({ $active, theme }) => ($active ? "#ffffff" : theme.primary)};
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 16px rgba(10, 134, 80, 0.14);
  }
`;
